import { isMicrosoftTemplate } from 'utils/templateGuards';
import { WORKSPACE_TYPES, WorkspaceType } from '../types/workspace';
import { useGenerateExerciseWorkspaceTeamSite } from './useGenerateExerciseWorkspaceTeamSite';
import { useSaveCustomTeamTemplate } from './useSaveCustomTeamTemplate';
import { useGenerateIncidentWorkspaceTeamSite } from './useGenerateIncidentWorkspaceTeamSite';
import { useGenerateCustomTeamSite } from './useGenerateCustomTeamSite';
import { CustomTemplate, MicrosoftTemplate } from 'types/template';
import { Channel } from 'types/channels';

export const useTemplateGeneration = (
  workspaceType: WorkspaceType,
  workspaceId: string,
  tenantId: string
) => {
  const generateExerciseWorkspaceTeamSite =
    useGenerateExerciseWorkspaceTeamSite();
  const generateIncidentWorkspaceTeamSite =
    useGenerateIncidentWorkspaceTeamSite();
  const generateCustomTeamTemplate = useSaveCustomTeamTemplate();
  const generateCustomTeamSite = useGenerateCustomTeamSite();

  const generateTeamsSiteClicked = (template: MicrosoftTemplate) => {
    generateExerciseWorkspaceTeamSite.mutate({
      workspaceId: workspaceId as UUID,
      template,
      tenantId,
    });
  };

  const generateIncidentWorkspaceTeamSiteClicked = (
    template: MicrosoftTemplate
  ) => {
    generateIncidentWorkspaceTeamSite.mutate({
      incidentId: workspaceId,
      template,
      tenantId,
    });
  };

  const generateCustomTeamsTemplateClicked = ({
    channels,
    description,
    label,
  }: {
    channels?: Channel[];
    description?: string;
    label: string;
  }) => {
    generateCustomTeamTemplate.mutate({
      workspaceType,
      workspaceId,
      channels: channels || [],
      tenantId,
      description,
      label,
    });
  };

  const generateCustomTeamSiteClicked = ({
    channels,
  }: {
    channels?: Channel[];
  }) => {
    generateCustomTeamSite.mutate({
      workspaceType,
      workspaceId,
      channels: channels || [],
      tenantId,
    });
  };

  const handleOnSave = (template: CustomTemplate) => {
    generateCustomTeamsTemplateClicked({
      channels: template?.channels,
      description: template?.description,
      label: template.label,
    });
  };

  const handleOnLaunch = (template: CustomTemplate | MicrosoftTemplate) => {
    if (isMicrosoftTemplate(template)) {
      if (workspaceType === WORKSPACE_TYPES.EXERCISE) {
        generateTeamsSiteClicked(template);
      } else {
     
        generateIncidentWorkspaceTeamSiteClicked(template);
      }
    } else {
      const channels = template?.channels;
      generateCustomTeamSiteClicked({
        channels,
      });
    }
  };

  return {
    handleOnSave,
    handleOnLaunch,
  };
};
